import { ConfigStateInterface } from '../core/config/reducer';

export const configStateSelector = (state: any): ConfigStateInterface => {
  return state.config;
};
